module.exports = __webpack_public_path__ + "img/pic.4f5ee754.png";